(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fg-product-assurance"] && !Shopify.designMode) return;
  try {
    class FgProductSave extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.label = this.querySelector('[data-save-label]');
      this.storageKey = 'fg-saved-products';

      if (!this.button || !this.dataset.productId) return;

      this.updateState();
      this.button.addEventListener('click', this.toggle);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggle);
    }

    getSavedProducts() {
      try {
        return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
      } catch {
        return [];
      }
    }

    updateState() {
      const isSaved = this.getSavedProducts().includes(this.dataset.productId);
      this.button.setAttribute('aria-pressed', String(isSaved));
      this.label.textContent = isSaved ? 'Saved' : 'Save item';
    }

    toggle = () => {
      const savedProducts = this.getSavedProducts();
      const productId = this.dataset.productId;
      const nextProducts = savedProducts.includes(productId)
        ? savedProducts.filter((id) => id !== productId)
        : [...savedProducts, productId];

      localStorage.setItem(this.storageKey, JSON.stringify(nextProducts));
      this.updateState();
    };
  }

  if (!customElements.get('fg-product-save')) {
    customElements.define('fg-product-save', FgProductSave);
  }
  } catch(e) { console.error(e); }
})();

})();
